/* Action */
.cardAction {
  margin-top: auto;
  width: 100%;
  padding: 0;
}

button.cardAction_button {
  border-radius: 0;
}

button.cardAction_button::before,
button.cardAction_button:hover::before,
button.cardAction_button:focus-visible::before {
  border-radius: 0;
}
